import React, {useEffect, useState} from 'react';
import {getPythonExecutions} from "../../api/python/python-execution-service";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import PythonExecutions from "../../components/PythonExecutions/PythonExecutions";


const PythonExecution = () => {
    const [loading, setLoading] = useState(true)
    const [pythonExecutions, setPythonExecutions] = useState([])
    const [selectedPythonExecutionIndex, setSelectedPythonExecutionIndex] = useState(-1)


    useEffect(() => {
        getPythonExecutions()
            .then(executions => {
                setPythonExecutions(executions)
                setLoading(false)
            })
        const intervalId = setInterval(() => {
            getPythonExecutions().then(executions => {
                setPythonExecutions(executions)
            })
        }, 10000)
        return () => clearInterval(intervalId);
    }, []);

    return (
        loading
            ? (<LoadingScreen/>) :

            <PythonExecutions
                setPythonExecutions={setPythonExecutions}
                pythonExecutions={pythonExecutions}
                selectedPythonExecutionIndex={selectedPythonExecutionIndex}
                setSelectedPythonExecutionIndex={setSelectedPythonExecutionIndex}
            />


    );
}

export default PythonExecution;